export const OBJECT_RECORD = {
    ADDRESSZERO: '0x0000000000000000000000000000000000000000000000000000000000000000',
    CLOCKOBJECT: "0x0000000000000000000000000000000000000000000000000000000000000006",
    COIN_SUI: "0x2::sui::SUI",
    PACKAGE_ID: '0xa1ff865eda64a5d02a81d67b0f829bdb1a964d300b4ba978a1001aecd8b0dedf',
    PRESALE: '0x4be383be6f0d46cf12a60bfee3ffe973cd4b58dc2149239c3ee3d06fa7aaa590',
    TREASURY: '0x51768ca7632448338419e2e99c864fd02ab940752e069994da058fee600ea681',
    USER_STATE: '0xf309ce8d738e1502dd98e84beafe4f44be2b831537d34d3d47a7f61281ef2a02',
    ADMIN_CAP: '0x811e19a2bc97f714f66a40eaee61768720aef14dd30ecbd5032860b07498a768',
};

export const LAMPORT = 1000000000;
